module.exports = __webpack_public_path__ + "static/media/54_1157.c081075f.webp";